import React from 'react'

export function Notification({
  header,
  body,
  iconClass,
  variant,
  className,
  buttons,
  showCloseButton = false,
}: {
  header?: React.ReactNode
  body: React.ReactNode
  iconClass: string
  variant: string
  className?: string
  buttons?: React.ReactNode
  showCloseButton?: boolean
}): JSX.Element | null {
  const [showNotification, setShowNotification] = React.useState(true)

  if (!showNotification) {
    return null
  }

  const closeButton = showCloseButton ? (
    <button
      className="ds3-icon ds3-close bg-transparent p-0 border-0 position-absolute"
      style={{ top: '-12px', right: '-12px' }}
      onClick={() => setShowNotification(false)}
    />
  ) : null

  return (
    <div className={`notification notification-variant-${variant} p-4 d-flex gap-3 ${className}`}>
      <span className={`notification-icon ${iconClass} p-2 pe-none`} />
      <div className="d-flex flex-column gap-1 w-100">
        <div className="d-flex flex-md-row flex-column justify-content-between align-items-md-end position-relative">
          <div className="d-flex flex-column gap-1">
            {header && <span className="fw-medium">{header}</span>}
            <div className="d-flex gap-1 flex-wrap">{body}</div>
          </div>

          <div className="d-flex flex-column align-items-end justify-content-end h-100 mt-md-0 mt-2">
            {closeButton}
            <div className="d-flex flex-md-row flex-column align-items-end gap-2">{buttons}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
